"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldString = void 0;
var RootClass = require("./rootClass");
var FieldString = (function (_super) {
    __extends(FieldString, _super);
    function FieldString(typeObj, jSonDoc, srvType) {
        if (srvType === void 0) { srvType = 1; }
        var _this = this;
        if (typeObj !== "string") {
            throw new Error("wrong objectType for a string field");
        }
        _this = _super.call(this, typeObj, jSonDoc, srvType) || this;
        return _this;
    }
    FieldString.prototype.encode = function (jsonData) {
        return _super.prototype.encode.call(this, jsonData);
    };
    FieldString.prototype.decode = function () {
        return _super.prototype.decode.call(this);
    };
    FieldString.prototype.setProp = function (propName, value) {
        return _super.prototype.setProp.call(this, propName, value);
    };
    FieldString.prototype.save = function () {
        return _super.prototype.save.call(this, 0);
    };
    FieldString.prototype.getPossibleValues = function () {
        if (this.listField <= 0) {
            throw new Error("No listField in use");
        }
        var myListF = this.myApi.getListDef(this.listField);
        if (myListF === null) {
            throw new Error("internal error");
        }
        return myListF.values;
    };
    FieldString.prototype.changeToLinkedField = function (ptId, remoteEntity, remoteField, verbFrom, verbTo, remoteEntityName, remoteFieldSingular, maxLength, lfUiType) {
        var _this = this;
        if (ptId === void 0) { ptId = -1; }
        if (remoteEntity === void 0) { remoteEntity = -1; }
        if (remoteField === void 0) { remoteField = -1; }
        if (verbFrom === void 0) { verbFrom = ""; }
        if (verbTo === void 0) { verbTo = ""; }
        if (remoteEntityName === void 0) { remoteEntityName = ""; }
        if (remoteFieldSingular === void 0) { remoteFieldSingular = ""; }
        if (maxLength === void 0) { maxLength = -1; }
        if (lfUiType === void 0) { lfUiType = "linkedField"; }
        if (["linkedField", "lookup"].indexOf(lfUiType) === -1) {
            throw new Error("invalid parameter " + lfUiType);
        }
        var updatePt = ptId === -1 ? true : false;
        var fieldCNUsingThisTemplate = -1;
        this.myApi.entities.getAllEntities().forEach(function (anEntity) {
            anEntity.fields.forEach(function (aField) {
                if (aField.systemType === "linkedField") {
                    var aLFi = aField;
                    if (aLFi.isFieldUsedInTemplate(_this.id)) {
                        fieldCNUsingThisTemplate = aField.id;
                    }
                    if (aLFi.linkedRelation[0] === ptId) {
                        updatePt = false;
                    }
                }
            });
        });
        if (fieldCNUsingThisTemplate !== -1) {
            throw new Error("This field is used in linkedField " + fieldCNUsingThisTemplate);
        }
        var opts = "rcn=" + ptId + "&reCN=" + remoteEntity + "&rfCN=" + remoteField +
            "&verbFrom=" + verbFrom + "&verbTo=" + verbTo + "&reEntName=" + remoteEntityName +
            "&reFieldSing=" + remoteFieldSingular +
            "&maxLen=" + maxLength + "&updatePt=" + updatePt + "&lfUIType=" + lfUiType + "&srcType=string";
        return this.myApi.restApi.promoteToFi(this.eCN, this.id, opts);
    };
    FieldString.prototype.testMerge = function (eCN, fCN, bAddNonExistingDocs, bDeleteEntity) {
        var e_1, _a, e_2, _b, e_3, _c;
        if (bDeleteEntity === void 0) { bDeleteEntity = true; }
        if (this.toClass().systemType !== "string") {
            throw new Error("testMerge can only be done on a string field");
        }
        var mergeTask = {
            addNonExistingDoc: bAddNonExistingDocs,
            deleteEntity: bDeleteEntity,
            fromECN: this.toClass().eCN,
            lfMapping: [],
            mapping: [],
            newFields: [],
            toECN: eCN,
        };
        var aMappingKeyMerge = {
            bNewOnly: true,
            fromFCN: "key::" + this.computePath(this.id, this.toClass().jSonCN),
            toFCN: "c" + fCN,
        };
        mergeTask.mapping.push(aMappingKeyMerge);
        var fromEnt = this.myApi.entities.getByEcn(this.toClass().eCN);
        var toEnt = this.myApi.entities.getByEcn(eCN);
        if (fromEnt === null) {
            throw new Error("cannot find entity object of this field...");
        }
        if (toEnt === null) {
            throw new Error("target entity object not found, eCN: " + eCN);
        }
        try {
            for (var _d = __values(fromEnt.getFieldByTypes(["string", "number"])), _e = _d.next(); !_e.done; _e = _d.next()) {
                var aStrFi = _e.value;
                if (aStrFi.id === this.toClass().id) {
                    continue;
                }
                var aMapping = {
                    bNewOnly: true,
                    fromFCN: this.computePath(aStrFi.id, aStrFi.jSonCN),
                    toFCN: -1,
                };
                try {
                    for (var _f = (e_2 = void 0, __values(toEnt.getFieldByType("linkedField"))), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var destFi = _g.value;
                        if (destFi.id === fCN) {
                            continue;
                        }
                        if (aStrFi.singular.toLowerCase() === destFi.singular.toLowerCase() && aStrFi.systemType === "string") {
                            aMapping.toFCN = "c" + destFi.linkedRelation;
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                if (aMapping.toFCN !== -1) {
                    aMapping.bNewOnly = false;
                    mergeTask.lfMapping.push(aMapping);
                    continue;
                }
                try {
                    for (var _h = (e_3 = void 0, __values(toEnt.getFieldByTypes(["number", "string"]))), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var destFi = _j.value;
                        if (destFi.id === fCN) {
                            continue;
                        }
                        if (aStrFi.singular.toLowerCase() === destFi.singular.toLowerCase()) {
                            if (aStrFi.systemType !== destFi.systemType) {
                                throw new Error("incompatible field type");
                            }
                            aMapping.toFCN = destFi.fcnbb;
                            break;
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                if (aMapping.toFCN === -1) {
                    aMapping.bNewOnly = false;
                    mergeTask.newFields.push({
                        c1: toEnt.id,
                        c2: "F",
                        c3: aStrFi.singular,
                        c6: "text",
                        c30: {},
                        c7: "string",
                    });
                    aMapping.toFCN = mergeTask.newFields.length - 1;
                }
                mergeTask.mapping.push(aMapping);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return mergeTask;
    };
    FieldString.prototype.merge = function (eCN, fCN, bAddNonExistingDocs, bDeleteEntity) {
        var _this = this;
        if (bAddNonExistingDocs === void 0) { bAddNonExistingDocs = false; }
        if (bDeleteEntity === void 0) { bDeleteEntity = true; }
        return new Promise(function (c, r) {
            var mergeTask = _this.testMerge(eCN, fCN, bAddNonExistingDocs, bDeleteEntity);
            if (mergeTask.mapping.length === 1) {
                return r("no common field found");
            }
            _this.myApi.restApi.mergeDocuments(mergeTask)
                .then(function () {
                return c(_this.myApi.entities.getByEcn(mergeTask.fromECN));
            })
                .catch(function (err) {
                return r(err);
            });
        });
    };
    FieldString.prototype.postProcess = function () {
        _super.prototype.postProcess.call(this);
        if (this.jSonCN !== -1) {
            var myEntiti = this.myApi.entities.getByEcn(this.eCN);
            if (myEntiti !== null) {
                var jSonField = myEntiti.getField(this.jSonCN);
                if (jSonField !== null) {
                    jSonField.postProcess();
                }
            }
        }
    };
    FieldString.prototype.toClass = function () {
        return this;
    };
    FieldString.prototype.computePath = function (fCN, jsonCN) {
        if (jsonCN === -1) {
            return "c" + fCN;
        }
        return "c" + jsonCN + ".c" + fCN;
    };
    return FieldString;
}(RootClass.RootClass));
exports.FieldString = FieldString;
